var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.4293 11.9995C13.4293 11.4614 13.2159 10.9448 12.836 10.5638L2.62275 0.350496C2.15412 -0.118134 1.39432 -0.118134 0.925692 0.350496C0.691252 0.584936 0.574095 0.892244 0.57422 1.19951C0.574096 1.50678 0.691253 1.81409 0.925692 2.04853L10.8767 11.9995L0.925691 21.9505C0.691252 22.1849 0.574095 22.4922 0.574219 22.7995C0.574095 23.1068 0.691252 23.4141 0.925691 23.6485C1.39432 24.1172 2.15412 24.1172 2.62275 23.6485L12.836 13.4353C13.2159 13.0542 13.4293 12.5376 13.4293 11.9995Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 14 24","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
